import { Toaster as Sonner, type ToasterProps } from 'sonner';

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      toastOptions={{
        classNames: {
          toast:
            '[&_a]:underline [&_a]:cursor-pointer [&_a]:text-blue-500 [&_a:hover]:no-underline',
          success: '!text-white [&_[data-icon]]:!text-emerald-500',
          warning: '!text-white [&_[data-icon]]:!text-amber-400',
          error:
            '!bg-danger-700 !border !border-danger-500 !text-white [&_[data-icon]]:!text-danger-500',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
